function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("rect", {
  fill: "none",
  id: "canvas_background",
  height: 19,
  width: 16,
  y: -1,
  x: -1
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  stroke: "null",
  id: "svg_1",
  d: "m12.43531,0l-10.94307,0c-0.82371,0 -1.49224,0.57397 -1.49224,1.28275l0,15.43624a0.19896,0.16956 0 0 0 0.33227,0.12717l1.65539,-1.28445a0.49443,0.42137 0 0 1 0.66653,0l1.65539,1.2836c0.18902,0.14667 0.47752,0.14667 0.66653,0l1.65439,-1.2836a0.49443,0.42137 0 0 1 0.66653,0l1.65439,1.2836c0.18902,0.14667 0.47752,0.14667 0.66653,0l1.65539,-1.2836a0.49443,0.42137 0 0 1 0.66653,0l1.65539,1.28445a0.19896,0.16956 0 0 0 0.33227,-0.12717l0,-15.43624c0,-0.70878 -0.66852,-1.28275 -1.49224,-1.28275zm-0.49741,4.23909l0,-0.84782l-9.94824,0l0,1.69564l9.94824,0l0,-0.84782zm0,2.54346l0,1.69564l-9.94824,0l0,-1.69564l9.94824,0zm-3.9793,4.23909l0,-0.84782l-5.96894,0l0,1.69564l5.96894,0l0,-0.84782z",
  fillRule: "evenodd"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 13.999999999999998,
    height: 17
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "storage/admin_static/media/receipt.cad59d53.svg";
export { SvgComponent as ReactComponent };